import { render, staticRenderFns } from "./ModalReceiveItemForm.vue?vue&type=template&id=397b0036&"
import script from "./ModalReceiveItemForm.vue?vue&type=script&lang=js&"
export * from "./ModalReceiveItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports